import client from "~/apis/client"

export function getSession() {
  return client.get("/session")
}

export function signIn(emailAddress, password) {
  return client.post("/session", { email_address: emailAddress, password })
}

export function signOut() {
  return client.delete("/session")
}
